import { render, staticRenderFns } from "./SalesPersonnel.vue?vue&type=template&id=f56387e8"
import script from "./SalesPersonnel.vue?vue&type=script&lang=js"
export * from "./SalesPersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports